import React, { useState } from 'react'
// eslint-disable-next-line no-restricted-imports
import { Switch, SwitchProps } from 'antd'
import { SwitchChangeEventHandler } from 'antd/es/switch'

export type { SwitchProps }

export default (props: SwitchProps) => {
    const { onChange, ...restProps } = props
    const [loading, setLoading] = useState(false)

    const onChangeHelper: SwitchChangeEventHandler = async (checked, event) => {
        setLoading(true)
        try {
            await onChange?.(checked, event)
        } catch (error) {
            console.error('error', error)
        }

        setLoading(false)
    }

    return <Switch size="small" loading={loading} onChange={onChangeHelper} {...restProps} />
}
